/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentTumor from './treatment-tumor';
import TreatmentTumorDetail from './treatment-tumor-detail';
import TreatmentTumorUpdate from './treatment-tumor-update';
import TreatmentTumorDeleteDialog from './treatment-tumor-delete-dialog';

const TreatmentTumorRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentTumor />} />
    <Route path="new" element={<TreatmentTumorUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentTumorDetail />} />
      <Route path="edit" element={<TreatmentTumorUpdate />} />
      <Route path="delete" element={<TreatmentTumorDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentTumorRoutes;
